import { FormattedMessage } from 'react-intl';

import DateStamp from '@components/dates/DateStamp';
import ExpertAvatar from '@components/ExpertAvatar';
import styles from '@components/expertSection/ExpertSection.module.css';
import ExpertSessionCard from '@components/expertSection/ExpertSessionCard';
import ExpertScheduleSession from '@components/expertSection/schedule/ExpertScheduleSession';
import NextConsultForm from '@components/forms/NextConsultForm';
import Icon from '@components/text/Icon';
import BodyCopy from '@components/typography/BodyCopy';
import BodyCopyBold from '@components/typography/BodyCopyBold';
import Heading1 from '@components/typography/Heading1';
import Heading2 from '@components/typography/Heading2';
import { GetJourneyWithExpertAndConsultsQuery } from '@typing/Generated';
import { sortByTimestamp } from '@utils/modelUtils';

type Props = {
  journey: GetJourneyWithExpertAndConsultsQuery['journey'];
};

const ExpertSessions = ({ journey }: Props) => {
  const consults = sortByTimestamp(journey.consults, consult => consult.startTime);

  return (
    <div>
      <div className={styles.spacingBottomExtraLarge}>
        <Heading1>
          <FormattedMessage id="pages.expertSection.sessionDetails" />
        </Heading1>
      </div>
      <div>
        <div>
          <div className={styles.spacingBottomExtraLarge}>
            <Heading2>
              <FormattedMessage id="pages.expertSection.historyAndUpcoming" />
            </Heading2>
          </div>
          <div className={styles.expertSessions}>
            <div className={styles.sessionCard + ' ' + styles.sessionCardPurple}>
              <div className={styles.sessionCardTop}>
                <div className={styles.expertAndTime}>
                  {journey.primaryExpert && <ExpertAvatar expert={journey.primaryExpert} size={36} />}
                  {journey.careProfile.nextConsult && journey.primaryExpert && (
                    <div>
                      <BodyCopyBold color="primary700">
                        <DateStamp value={journey.careProfile.nextConsult} />
                      </BodyCopyBold>
                    </div>
                  )}
                </div>
                <div className={styles.expertContact}>
                  <BodyCopy color="primary700">
                    <FormattedMessage id="pages.expertSection.nextRecommended" />
                  </BodyCopy>
                </div>
                <div className={styles.consultItems + ' align-right'}>
                  <NextConsultForm
                    careProfileId={journey.careProfile.id}
                    nextConsult={journey.careProfile.nextConsult}
                    nextConsultDraft={journey.careProfile.nextConsultDraft}
                  />
                </div>
              </div>
            </div>
            {consults.map(consult => (
              <ExpertSessionCard consult={consult} journey={journey} key={consult.id} />
            ))}
          </div>
        </div>
        <div className={styles.spacingTopLarge}>
          <div className={styles.spacingBottomLarge}>
            <Heading2>
              <Icon ariaLabelKey="accessibility.ariaLabels.clock" className={styles.clock} icon="clock" />
              <FormattedMessage id="pages.expertSection.schedule" />
            </Heading2>
          </div>
          <ExpertScheduleSession journey={journey} />
        </div>
      </div>
    </div>
  );
};

export default ExpertSessions;
